import { Box, Button, Stack, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';
import useScreenSize from '../../utils/useScreenSize';
import getMuiIcon from '../../utils/getMuiIcon';

export const ListItem: React.FC<{
    header: string
    subHeader: string
    title: string
    buttonText: string
    onButtonClick:  VoidFunction
    testId: string
}> = ({
  header,
  subHeader,
  testId,
  title,
  buttonText,
  onButtonClick,
}) => {
  const { isXsScreen } = useScreenSize();

  return (    
    <Stack
      data-testid={testId}
      sx={{
        border: `1px solid ${palette.components.input.outlined.enabledBorder}`,
        borderRadius: borderRadius.sm,
      }}
      paddingX={spaces.sm}
      paddingY={spaces.md}
      direction={isXsScreen ? 'column' : 'row'}
      gap={spaces.md}
      alignItems={isXsScreen ? 'end' : 'center'}
    >
      <Stack
        direction='column'
        gap={spaces.xs}
        paddingY={spaces.xxs}
        width='100%'
      >
        <Typography variant='overline'>{header}</Typography>
        <Typography variant='h6' color={palette.text.primary}>{title}</Typography>
        <Typography variant='caption' color={palette.text.secondary}>{subHeader}</Typography>
      </Stack>
      <Box sx={{ flexShrink: 0 }}>
        <Button
          variant='text'
          startIcon={
            <SvgIcon component={getMuiIcon('importIcon')} viewBox='0 0 20 20' />
          }
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </Box>
    </Stack>
  );
};
